import { hasPropertiesOfType } from "util/Utils";

export class Program
{
    guid: string = '';
    name: string = '';

    private static readonly stringProps = ['guid', 'name'];

    static fromJson(json: any): Program | undefined
    {
        if (typeof json === 'object' &&
            hasPropertiesOfType(json, 'string', Program.stringProps))
        {
            const program = new Program();

            program.guid = json.guid;
            program.name = json.name;

            return program;
        }
        else
        {
            return undefined;
        }
    }
}